import { createAction, props } from '@ngrx/store';
import { UserApiModel } from 'app/models/user-api.model';

export const loadUsers = createAction('[Users] Load');

export const loadUsersSuccess = createAction(
  '[Users] Load Successful',
  props<{ items: UserApiModel[] }>()
);

export const loadUsersFailed = createAction(
  '[Users] Load Failed',
  props<{ error: any }>()
);

export const resetUsers = createAction('[Users] Reset');
